<app-template>
    <app-breadcrumb>
    <li class="breadcrumb-item">Administration</li>
    <li class="breadcrumb-item active"> System Admin Panel</li>
</app-breadcrumb>
</app-template>